"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = exports.generateCustomCode = exports.splitFullName = exports.slugify = void 0;
const slugify = (name) => {
    return name
        .toLowerCase() // Convert to lowercase
        .trim() // Remove leading and trailing whitespace
        .replace(/[^\w\s-]/g, '') // Remove non-alphanumeric characters except spaces and hyphens
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-'); // Replace multiple hyphens with a single hyphen
};
exports.slugify = slugify;
const splitFullName = (fullName) => {
    const nameParts = fullName.trim().split(/\s+/);
    let firstName = '';
    let lastName = '';
    if (nameParts.length > 0) {
        firstName = nameParts[0];
    }
    if (nameParts.length > 1) {
        lastName = nameParts.slice(1).join(' ');
    }
    return { firstName, lastName };
};
exports.splitFullName = splitFullName;
const generateCustomCode = (length = 12) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const charactersLength = characters.length;
    const result = new Array(length);
    for (let i = 0; i < length; i++) {
        result[i] = characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result.join('');
};
exports.generateCustomCode = generateCustomCode;
const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
exports.capitalize = capitalize;
//# sourceMappingURL=string.js.map